import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { DateStyles } from '../../constants/CentricConstants';
import { statusColours } from '../../constants/ColourConstants';

import { FormattedDate } from 'react-intl';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import WaitingIcon from 'material-ui/svg-icons/action/schedule';
import StatusIcon from 'material-ui/svg-icons/action/done';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import DidNotAttendIcon from 'material-ui/svg-icons/content/clear';

import EventActions from '../../actions/EventActionCreator';
import { formatName } from '../../utils/StringUtils';

const getIcon = (status, deleted = false) => {
    switch (status) {
        case 'waiting':
            return <WaitingIcon color={!deleted ? statusColours.default : statusColours.deleted} style={!!deleted && {paddingRight: 12}}/>;
        case 'attending':
            return <StatusIcon color={!deleted ? statusColours.primary : statusColours.deleted} style={!!deleted && {paddingRight: 12}}/>;
        case 'cancelled':
            return <DidNotAttendIcon color={!deleted ? statusColours.medium : statusColours.deleted} style={!!deleted && {paddingRight: 12}}/>;
        case 'attended':
            return <StatusIcon color={!deleted ? statusColours.passed : statusColours.deleted} style={!!deleted && {paddingRight: 12}}/>;
        case 'did_not_attend':
            return <DidNotAttendIcon color={!deleted ? statusColours.expired : statusColours.deleted} style={!!deleted && {paddingRight: 12}}/>;
        default:
            return <StatusIcon/>;
    }
};
const statusItems = [
    {key: 'waiting',        primaryText: 'Waiting',        leftIcon: getIcon('waiting')},
    {key: 'attending',      primaryText: 'Attending',      leftIcon: getIcon('attending')},
    {key: 'cancelled',      primaryText: 'Cancelled',      leftIcon: getIcon('cancelled')},
    {key: 'attended',       primaryText: 'Attended',       leftIcon: getIcon('attended')},
    {key: 'did_not_attend', primaryText: 'Did not attend', leftIcon: getIcon('did_not_attend')},
];

class EventAttendeeTableRow extends Component {

    componentDidMount() {
        this.statusSelected = this.statusSelected.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    statusSelected({target}, {key}) {
        if (key !== this.props.row.status) {
            EventActions.changeAttendanceStatus(this.props.row, key);
        }
    }

    onDelete() {
        const fullName = formatName(this.props.row);

        if (confirm(`Do you want to remove ${fullName}?`)) {
            EventActions.removeAttendance(this.props.row);
        }
    }
    
    getActions(isEditable) {
        if (!this.context.auth.isAdmin()) { return (<StatusIcon />); } // guard: admin user
        if (!this.props.row.status || this.props.row.status === 'deleted') { return null; } // guard: entry has status and is not deleted

        let actions = [
            <IconButton key="delete" onClick={this.onDelete} >
                <DeleteIcon color={statusColours.medium} />
            </IconButton>
        ];
        if (!isEditable) {
            actions.unshift(getIcon(this.props.row.status, true));
        } else {
            const topRight = { horizontal: 'right', vertical: 'top' };
            const button = <IconButton>{getIcon(this.props.row.status)}</IconButton>;
            actions.unshift(
                <IconMenu
                    key="changeStatus"
                    iconButtonElement={button}
                    anchorOrigin={topRight}
                    targetOrigin={topRight}
                    onItemTouchTap={this.statusSelected}
                >
                    {statusItems.map(item => <MenuItem value={item.key} {...item} />)}
                </IconMenu>
            );
        }
        return actions;
    }

    render() {
        const { row, children, actions, ...others } = this.props;
        const fullName = formatName(row);
        const dateRegistered = row.dateRegistered && (<FormattedDate {...DateStyles.full} value={new Date(row.dateRegistered)} />);
        const userNotDeleted = !Number(row.userDeleted);
        return (
            <TableRow {...others} style={{color: userNotDeleted ? statusColours.default : statusColours.deleted}} selectable={userNotDeleted}>
                {children && children[0]}
                <TableRowColumn>
                    {userNotDeleted
                        ? <Link to={`/dashboard/user/${row.userId}`}>{fullName}</Link>
                        : <span title="Deleted user">{fullName}</span>
                    }
                </TableRowColumn>
                <TableRowColumn>{dateRegistered}</TableRowColumn>
                <TableRowColumn className="tbl-td-actions">{actions || this.getActions(userNotDeleted)}</TableRowColumn>
            </TableRow>
        );
    }
}

EventAttendeeTableRow.propTypes = {
    row:        PropTypes.shape({
        userId:     PropTypes.number.isRequired,
        firstName:  PropTypes.string.isRequired,
        lastName:   PropTypes.string.isRequired,
        title:      PropTypes.string,
        status:     PropTypes.string,
        dateRegistered: PropTypes.string
    })
};

EventAttendeeTableRow.contextTypes = {
    auth: PropTypes.object
};

export default EventAttendeeTableRow;
